const containsId = (mappingData) => (id) => mappingData.includes(id);

export {containsId}